import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  var selectedCourse = localStorage.getItem('etlSelectCourse'); 	
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
	//var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));

  const [open, setOpen] = React.useState(false);


  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function upgradeNow(){
		if(mySelectedCourses && selectedCourse>-1){
		  window.location.href="selectcourse?cid="+mySelectedCourses[selectedCourse].courseId;
		}
  }

  return (
    <>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent>
          <Grid item   md={12} xs={12} className="test-instructions" >
								<div className="btmbdrgry"><h3>Validity Expired</h3></div>
								<p>
                    <h3 style={{textAlign:'center',color:'#FF0000',fontWeight:'bold'}}>
											{(props.organisationName && props.organisationName.length>0)?<>{props.organisationName}'s</>:null} validity has been finished. Renew your account to continue to access Study Material.
										</h3>
                    <div style={{textAlign:'center', marginTop:30}}>
											<Button title="Renew Now" variant="contained" onClick={() => {upgradeNow()}} size="small" style={{marginBottom:5,textTransform:'none',backgroundColor:'#008140',color:'#FFF'}} >Renew Now</Button>
										</div>
								</p>
							</Grid>


          </DialogContent>
      </Dialog>
    </>
  );

});

export default CustomizedDialogs;
